import React, { lazy, Suspense } from 'react';
import { Navigate } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";

// import Result403 from "../pages/403";
// import Result404 from "../pages/404";
// import Result500 from "../pages/500";

const Fallback = () => {
    return <div>Loading...</div>;
};

const Login = lazy(() => import("../containers/Login"));
const Navigation = lazy(() => import("../containers/Navigation"));
const Payment = lazy(() => import("../containers/Payment"));
const History = lazy(() => import("../containers/History"));
const Electricity = lazy(() => import("../containers/Electricity"));
const Notice = lazy(() => import("../containers/Notice"));
const AnnouncementContent = lazy(() => import("../containers/AnnouncementContent"));
const Binding = lazy(() => import("../containers/Binding"));
const Unbinding = lazy(() => import("../containers/Unbinding"));
const Transfer = lazy(() => import("../containers/Transfer"));
const TransferIn = lazy(() => import("../containers/TransferIn"));
const TransferOut = lazy(() => import("../containers/TransferOut"));
const UnbindAll = lazy(() => import("../containers/UnbindAll"));
const ChangePassword = lazy(() => import("../containers/ChangePassword"));
const PersonalPayment = lazy(() => import("../containers/PersonalPayment"));
const RecordDetail = lazy(() => import("../containers/RecordDetail"));
const RefundApply = lazy(() => import("../containers/RefundApply"));
const RefundList = lazy(() => import("../containers/RefundList"));
const RefundModify = lazy(() => import("../containers/RefundModify"));

// 使用 RouteObject 类型定义路由配置，并定义 Suspense 包装的 element 类型
const withSuspense = (element) => <Suspense fallback={<Fallback />}>{element}</Suspense>;

const routes = [
    {
        path: "/login",
        element: withSuspense(<Login />),
    },
    {
        path: "/",
        element: withSuspense(<PrivateRoute><Navigation /></PrivateRoute>),
    },
    {
        path: "/payment",
        element: withSuspense(<PrivateRoute><Payment /></PrivateRoute>),
    },
    {
        path: "/history",
        element: withSuspense(<PrivateRoute><History /></PrivateRoute>),
    },
    {
        path: "/history/:recordId",
        element: withSuspense(<PrivateRoute><RecordDetail /></PrivateRoute>),
    },
    {
        path: "/electricity",
        element: withSuspense(<PrivateRoute><Electricity /></PrivateRoute>),
    },
    {
        path: "/notice",
        element: withSuspense(<PrivateRoute><Notice /></PrivateRoute>),
    },
    {
        path: "/announcement/:id",
        element: withSuspense(<PrivateRoute><AnnouncementContent /></PrivateRoute>),
    },
    {
        path: "/binding",
        element: withSuspense(<Binding />),
    },
    {
        path: "/unbinding",
        element: withSuspense(<PrivateRoute><Unbinding /></PrivateRoute>),
    },
    {
        path: "/transfer",
        element: withSuspense(<PrivateRoute><Transfer /></PrivateRoute>),
    },
    {
        path: "/transfer-in",
        element: withSuspense(<PrivateRoute><TransferIn /></PrivateRoute>),
    },
    // {
    //     path: "/transfer-out",
    //     element: withSuspense(<PrivateRoute><TransferOut /></PrivateRoute>),
    // },
    {
        path: "/unbind-all",
        element: withSuspense(<PrivateRoute><UnbindAll /></PrivateRoute>),
    },
    {
        path: "/change-password",
        element: withSuspense(<PrivateRoute><ChangePassword /></PrivateRoute>),
    },
    {
        path: "/refund-apply",
        element: withSuspense(<PrivateRoute><RefundApply /></PrivateRoute>),
    },
    {
        path: "/refund-list",
        element: withSuspense(<PrivateRoute><RefundList /></PrivateRoute>),
    },
    {
        path: "/refund-modify/:id",
        element: withSuspense(<PrivateRoute><RefundModify /></PrivateRoute>),
    },
    // {
    //     path: "/personal-payment",
    //     element: withSuspense(<PrivateRoute><PersonalPayment /></PrivateRoute>),
    // },
    {
        path: "/401",
        element: <div>无权限...</div>,
    },
    {
        path: "/403",
        element: <p>403</p>,
    },
    {
        path: "/404",
        element: <p>404</p>,
    },
    {
        path: "/500",
        element: <p>500</p>,
    },
    {
        path: "*",
        element: <Navigate to="/404" />,
    },
];

export default routes;
